import styled from 'styled-components';
import {InputNumber} from 'antd';

const StyledEuroInput = styled(InputNumber)`
  width: 100%;
  
  &.ant-input-number-group-wrapper-status-error {
    .ant-input-number-group-addon {
      &:first-child {
        border-color: ${props => props.theme.colors.functional_danger};
      }
    }
  }
  
  input.ant-input-number-input {
    font-family: 'Outfit', sans-serif;
    font-size: 16px;
    line-height: 1.5;
  }
  
  .ant-input-number-group-addon {
    background-color: transparent;
    svg {
      width: 16px;

      path {
        fill: ${props => props.theme.colors.neutral_6};
      }
    }
  }
`;

export {
  StyledEuroInput
};
